import { render, staticRenderFns } from "./ManrefType.vue?vue&type=template&id=b406c4fc"
import script from "./ManrefType.vue?vue&type=script&lang=js"
export * from "./ManrefType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports